import { useState, useEffect } from 'react';

import { DialogTitle, Grid, FormControl, FormControlLabel, RadioGroup, Radio } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';

import { StandardDialogActions, RoundedDialog } from '../../../../Global/Components';
import StateManager from '../../../../Global/StateManager';
import axios from 'axios';

const LocationSelectDialog = ({ open, onClose, initial, documentId }) => {
  const [saving, setSaving] = useState(false);
  const [locationIds, setLocationIds] = useState([]);
  const [value, setValue] = useState('no-tasks');

  const handleRadioChange = (event) => {
    setValue(event.target.value);
  };

  const handleDone = () => {
    if (value === 'no-tasks') {
      onClose();
      return;
    }
    if (value === 'create-tasks') {
      setSaving(true);
      const data = { locationIds, documentId };
      axios
        .post('dochub/locations/allocate-task', data)
        .then(() => {
          setSaving(false);
          StateManager.setSuccessAlert(`Allocation task${initial?.length > 1 ? 's' : ''} created successfully`);
          onClose();
        })
        .catch((err) => {
          setSaving(false);
          StateManager.setAxiosErrorAlert(err);
        });
      return;
    }
    if (value === 'create-autocomplete-tasks') {
      setSaving(true);
      const data = { locationIds, documentId };
      axios
        .post('dochub/locations/allocate-autocomplete-task', data)
        .then(() => {
          setSaving(false);
          StateManager.setSuccessAlert(
            `Allocation task${initial?.length > 1 ? 's' : ''} created and completed successfully`,
          );
          onClose();
        })
        .catch((err) => {
          setSaving(false);
          StateManager.setAxiosErrorAlert(err);
        });
      return;
    }
    StateManager.setErrorAlert('Please select an option');
  };

  useEffect(() => {
    if (!open) return;
    setValue('no-tasks');
    setLocationIds(initial || []);
  }, [open, initial]);

  return (
    <RoundedDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Would you like to create allocation tasks for the new locations you added?</DialogTitle>
      <DialogContent>
        <Grid containergap={2}>
          <FormControl sx={{ m: 3 }} variant="standard">
            <RadioGroup aria-labelledby="locations-options" name="options" value={value} onChange={handleRadioChange}>
              <FormControlLabel value="no-tasks" control={<Radio />} label="No don't create tasks." />
              <FormControlLabel value="create-tasks" control={<Radio />} label="Create tasks." />
              <FormControlLabel
                value="create-autocomplete-tasks"
                control={<Radio />}
                label="Create tasks and auto complete them."
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </DialogContent>
      <StandardDialogActions onClose={onClose} onDone={handleDone} disableDone={!value} saving={saving} />
    </RoundedDialog>
  );
};
export default LocationSelectDialog;
